<template>
  <div class="generated-items">
    <div class="row align-items-stretch h-100 mx-0">
      <div class="col-12 col-md-9 col-lg-10 order-1 order-md-0">
        <div class="d-flex justify-content-between align-items-center border-bottom">
          <h5 class="text-dark my-1 title w-auto">Artefatos criados</h5>
          <ExportImportItems class="d-inline" />
        </div>
        <GeneratedItemsList :generated-items="generatedItems" />
      </div>
      <div class="col-12 col-md-3 col-lg-2 order-0 order-md-1 border-left bg-white">
        <div class="h-100 d-flex flex-column justify-content-center align-items-center">
          <button
            class="btn btn-dark export-to-pdf"
            type="button"
            @click="exportToPdf"
            :disabled="!hasGeneratedItems"
          >
            <i class="fa fa-file-pdf-o mr-1"></i>
            <strong>Materializar artefatos</strong>
          </button>
          <p class="text-muted text-center m-0 mt-1">
            <small>Arquivo em formato .pdf</small><br />
            <small>Tamanho A4 (Paisagem)</small><br />
            <small>4 artefatos por folha</small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'

  import { EXPORT_PDF } from '../store/modules'
  import ExportImportItems from './ExportImportItems.vue'
  import GeneratedItemsList from './GeneratedItemsList.vue'

  export default {
    name: 'GeneratedItems',
    components: {
      ExportImportItems,
      GeneratedItemsList
    },
    computed: {
      ...mapState([ 'generatedItems' ]),
      ...mapFields(EXPORT_PDF, [
        'format',
        'orientation'
      ]),
      ...mapGetters([ 'hasGeneratedItems' ])
    },
    methods: {
      ...mapActions(EXPORT_PDF, [ 'exportToPdf' ])
    }
  }
</script>

<style lang="scss" scoped>
  .generated-items {
    background: linear-gradient(to right, rgba(#eee, .85), rgba(#fff, .85)),
                url("../../public/assets/items-background.jpg");
    background-repeat: repeat;
  }

  .w-auto {
    width: auto !important;
  }
</style>